import React, { useState, useEffect } from 'react';
import { useBranch } from '../../../layouts/BranchContext'; // fix path
import {
  Button,
  TextField,
  Tooltip,
  Container,
  Typography,
  InputAdornment,
  Box,
  Table,
  Modal,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  Paper,
  IconButton,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import {
  KeyboardDoubleArrowLeft as ChevronLeft,
  KeyboardDoubleArrowRight as ChevronRight,
  Search as SearchIcon,
  CloudUpload as CloudUploadIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const DuesList = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 25, 50];
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showUserGuideModal,setShowUserGuideModal]=useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [searchTerm, setSearchTerm] = useState('');
  const [monthFilter, setMonthFilter] = useState('all');
  const [showImportModal, setShowImportModal] = useState(false);
  const [importFile, setImportFile] = useState(null);

const [duesData, setDuesData] = useState([]);
const [loading, setLoading] = useState(true);
const [error, setError] = useState(null);
const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
const [selectedDuesId, setSelectedDuesId] = useState(null);
const [selectedStudent, setSelectedStudent] = useState(null);
const [modalPage, setModalPage] = useState(1);
const [modalRowsPerPage, setModalRowsPerPage] = useState(5);

  const [filteredData, setFilteredData] = useState([]);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_TOKEN = "Bearer " + localStorage.getItem('accessToken');

    const { selectedBranchId } = useBranch();

   useEffect(() => {
    setPage(1);
  }, [selectedBranchId]);

  // ===== End Branch Dropdown state =====
const safeParseJSON = (str, fallback = {}) => {
  try { return JSON.parse(str) || fallback; }
  catch { return fallback; }
};
  



  useEffect(() => {
  const fetchDues = async () => {
    try {
      setLoading(true);
      setError(null);

          const branchParam = selectedBranchId ? `?branch=${selectedBranchId}` : '';

      const response = await fetch(`${API_BASE_URL}/api/fee_details/payment/dues/${branchParam}`, {
        method: 'GET',
        headers: {
          'Authorization': API_TOKEN,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();

      // Ensure we have an array even if the API wraps it in an object
      let dataArray = [];
      if (Array.isArray(data)) {
        dataArray = data;
      } else if (data && Array.isArray(data.results)) {
        // common pattern for paginated responses
        dataArray = data.results;
      } else {
        console.warn('Unexpected dues payload format:', data);
        dataArray = [];
      }

      // adjust mapping according to actual API response structure
      const formattedData = dataArray.map((item, index) => ({
        id: item.id || index + 1,

admissionId: item.admission_no,
        admissionNo: item.admission_code || item.admission_no || '—',
        studentName: item.candidate_name || item.student_name || '—',
        mobileNo: item.mobile_no || item.mobileNo || '—',
        installmentDate: item.installment_date || item.date || '—',
        installmentCategory: item.installment_category || item.category || item.fee_type || item.installment_type || '—',
        installmentAmount: item.amount 
          ? `${item.amount}` 
          : item.installment_amount 
            ? `${item.installment_amount}` 
            : '—',
        paymentStatus: item.status === 'paid' || item.payment_status === 'Paid'
          ? 'Paid'
          : 'Unpaid',
      }));

      
const currentUser = safeParseJSON(
  sessionStorage.getItem("user")
);

const admissionNo =
  currentUser?.admission_details?.admission_no;

const finalData =
  currentUser?.role === "student"
    ? formattedData.filter(
        (item) => item.admissionId === admissionNo
      )
    : formattedData;

setDuesData(finalData);
    } catch (err) {
      console.error('Failed to fetch dues list:', err);
      setError(err.message || 'Failed to load dues data');
      setSnackbarMessage(err.message || 'Failed to load dues data');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  if (API_TOKEN && API_BASE_URL) {
    fetchDues();
  } else {
    setError('Authentication token or API base URL is missing');
    setLoading(false);
  }
}, [selectedBranchId]);


const handleDeleteClick = (id) => {
  setSelectedDuesId(id);
  setDeleteDialogOpen(true);
};

const handleDeleteConfirm = async () => {
  if (!selectedDuesId) return;

  try {
    const response = await fetch(`${API_BASE_URL}/api/fee_details/dues-list/${selectedDuesId}/`, {
      method: 'DELETE',
      headers: {
        'Authorization': API_TOKEN,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to delete: ${response.statusText}`);
    }

    // Remove from local state
    setDuesData((prev) => prev.filter((item) => item.id !== selectedDuesId));
    setSnackbarMessage('Dues record deleted successfully');
    setSnackbarSeverity('success');
  } catch (err) {
    console.error(err);
    setSnackbarMessage('Failed to delete record');
    setSnackbarSeverity('error');
  } finally {
    setOpenSnackbar(true);
    setDeleteDialogOpen(false);
    setSelectedDuesId(null);
  }
};

const handleDeleteCancel = () => {
  setDeleteDialogOpen(false);
  setSelectedDuesId(null);
};

  const handleFileChange = (e) => {
    setImportFile(e.target.files[0]);
  };

  const handleImport = () => {
    if (importFile) {
      // Placeholder for file import logic
      setSnackbarMessage('File imported successfully!');
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
      setShowImportModal(false);
      setImportFile(null);
    } else {
      setSnackbarMessage('Please select a file to import');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

//   const handleExport = async () => {
//   try {
//     setSnackbarMessage('Preparing export...');
//     setSnackbarSeverity('info');
//     setOpenSnackbar(true);

//     const response = await fetch(`${API_BASE_URL}/api/fee_details/payment/dues/export/`, {
//       method: 'GET',
//       headers: {
//         'Authorization': API_TOKEN,
//         'Content-Type': 'application/json',
//       },
//     });

//     if (!response.ok) {
//       throw new Error(`Export failed: ${response.status} ${response.statusText}`);
//     }

//     // Get filename from Content-Disposition header if present
//     const contentDisposition = response.headers.get('Content-Disposition');
//     let fileName = 'dues_list_export.csv'; // fallback

//     if (contentDisposition) {
//       const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/i);
//       if (fileNameMatch?.[1]) {
//         fileName = fileNameMatch[1];
//       }
//     }

//     // Get blob and trigger download
//     const blob = await response.blob();
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.setAttribute('download', fileName);
//     document.body.appendChild(link);
//     link.click();
//     link.parentNode.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     setSnackbarMessage('Export downloaded successfully!');
//     setSnackbarSeverity('success');
//   } catch (err) {
//     console.error('Export error:', err);
//     setSnackbarMessage(err.message || 'Failed to export dues list');
//     setSnackbarSeverity('error');
//   } finally {
//     setOpenSnackbar(true);
//   }
// };
useEffect(() => {
  const filtered = duesData.filter((dues) => {
    const matchesSearch = Object.values(dues).some((value) =>
      String(value ?? '').toLowerCase().includes(searchTerm.trim().toLowerCase())
    );

    let matchesMonth = true;
    if (monthFilter !== 'all' && dues.installmentDate && dues.installmentDate !== '—') {
      const dueDate = new Date(dues.installmentDate);
      matchesMonth = !Number.isNaN(dueDate.getTime()) &&
        dueDate.getMonth() === Number(monthFilter);
    } else if (monthFilter !== 'all') {
      matchesMonth = false;
    }

    return matchesSearch && matchesMonth;
  });

  setFilteredData(filtered);
  setPage(1);
}, [searchTerm, monthFilter, duesData]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

 

  const getInstallmentDate = (installment) => {
    if (!installment.installmentDate || installment.installmentDate === '—') return null;
    const date = new Date(installment.installmentDate);
    return Number.isNaN(date.getTime()) ? null : date;
  };

  const isUnpaid = (installment) => installment.paymentStatus !== 'Paid';

  const getInstallmentMonthKey = (installment) => {
    const date = getInstallmentDate(installment);
    return date ? `${date.getFullYear()}-${date.getMonth()}` : `unknown-${installment.id}`;
  };

  // One main-table row per student; all installment records remain available in View.
  const groupedStudents = filteredData.reduce((groups, installment) => {
    const key = String(installment.admissionId ?? installment.admissionNo ?? installment.studentName ?? installment.id);
    if (!groups[key]) {
      groups[key] = {
        key,
        admissionNo: installment.admissionNo,
        admissionId: installment.admissionId,
        studentName: installment.studentName,
        mobileNo: installment.mobileNo,
        installments: [],
      };
    }
    groups[key].installments.push(installment);
    return groups;
  }, {});

  const groupedData = Object.values(groupedStudents).map((student) => {
    // Keep the selected student's complete installment history in View,
    // even when the main table is filtered to a single month.
    const allStudentInstallments = duesData.filter((item) =>
      String(item.admissionId ?? item.admissionNo ?? item.studentName ?? item.id) === student.key
    );
    const installments = allStudentInstallments.length ? allStudentInstallments : student.installments;
    const unpaidInstallments = installments.filter(isUnpaid);
    const dueMonthCount = new Set(unpaidInstallments.map(getInstallmentMonthKey)).size;
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    const pastDue = unpaidInstallments.filter((item) => {
      const date = getInstallmentDate(item);
      return date && date < now;
    });
    const upcoming = unpaidInstallments.filter((item) => {
      const date = getInstallmentDate(item);
      return date && date >= now;
    });
    const outstandingAmount = unpaidInstallments.reduce((sum, item) => {
      const amount = Number(String(item.installmentAmount).replace(/[^0-9.-]/g, ''));
      return sum + (Number.isFinite(amount) ? amount : 0);
    }, 0);
    return { ...student, installments, dueMonthCount, pastDue, upcoming, unpaidInstallments, outstandingAmount };
  });

  const paginatedData = groupedData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const selectedInstallments = selectedStudent
    ? [...selectedStudent.installments].sort((a, b) => {
        const dateA = getInstallmentDate(a)?.getTime() ?? 0;
        const dateB = getInstallmentDate(b)?.getTime() ?? 0;
        return dateA - dateB;
      })
    : [];

  const modalNow = new Date();
  modalNow.setHours(0, 0, 0, 0);
  const modalPastDue = selectedInstallments.filter((item) => {
    const date = getInstallmentDate(item);
    return isUnpaid(item) && date && date < modalNow;
  });
  const modalUpcoming = selectedInstallments.filter((item) => {
    const date = getInstallmentDate(item);
    return isUnpaid(item) && date && date >= modalNow;
  });
  const modalDueMonthCount = new Set(
    selectedInstallments.filter(isUnpaid).map(getInstallmentMonthKey)
  ).size;
  const paginatedInstallments = selectedInstallments.slice(
    (modalPage - 1) * modalRowsPerPage,
    modalPage * modalRowsPerPage
  );

  const openStudentDetails = (student) => {
    setSelectedStudent(student);
    setModalPage(1);
    setModalRowsPerPage(5);
  };

  const currentUser = safeParseJSON(sessionStorage.getItem('user'));

  return (
    <Container>
      <Box
        sx={{
          display: 'flex',
          alignItems: { xs: 'stretch', sm: 'center' },
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 1.5,
          justifyContent: 'space-between',
          mb: 1,
          p: { xs: 1, sm: 2 },
          boxShadow: 'none',
          maxWidth: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            flex: 1,
            minWidth: 0,
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
          }}
        >
          <TextField
            variant="outlined"
            placeholder="Search by admission no., student name, or mobile..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    sx={{
                      color: theme.palette.primary.main,
                      marginLeft: 1.5,
                      fontSize: 24,
                    }}
                  />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => setSearchTerm('')}
                    sx={{
                      color: 'gray',
                      marginRight: 1,
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
              sx: {
                borderRadius: '30px',
                backgroundColor: theme.palette.mode === 'dark'
                  ? 'rgba(255, 255, 255, 0.15)'
                  : 'rgba(255, 255, 255, 1)',
                boxShadow: theme.palette.mode === 'dark'
                  ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                  : '0 2px 8px rgba(0, 0, 0, 0.1)',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                },
                '&:hover': {
                  backgroundColor: theme.palette.mode === 'dark'
                    ? 'rgba(255, 255, 255, 0.2)'
                    : 'rgba(240, 240, 240, 1)',
                  boxShadow: theme.palette.mode === 'dark'
                    ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                    : '0 2px 12px rgba(0, 0, 0, 0.15)',
                },
                '&.Mui-focused': {
                  backgroundColor: theme.palette.mode === 'dark'
                    ? 'rgba(255, 255, 255, 0.25)'
                    : 'rgba(255, 255, 255, 1)',
                  boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: `2px solid ${theme.palette.primary.main}`,
                  },
                },
                paddingLeft: 1.5,
                height: '50px',
                transition: 'all 0.3s ease',
              },
            }}
            sx={{
              width: { xs: '100%', sm: 350 },
              maxWidth: '100%',
              flex: { xs: '1 1 100%', sm: '0 1 350px' },
              '& .MuiInputBase-input': {
                padding: '10px 14px',
                color: theme.palette.text.primary,
                fontWeight: 500,
              },
            }}
          />

          <FormControl
            size="small"
            sx={{
              minWidth: { xs: '100%', sm: 170 },
              maxWidth: { xs: '100%', sm: 190 },
              flexShrink: 0,
              '& .MuiOutlinedInput-root': {
                height: 50,
                borderRadius: '12px',
                backgroundColor: theme.palette.background.paper,
              },
            }}
          >
            <InputLabel id="dues-month-filter-label">Month</InputLabel>
            <Select
              labelId="dues-month-filter-label"
              value={monthFilter}
              label="Month"
              onChange={(e) => setMonthFilter(e.target.value)}
            >
              <MenuItem value="all">All Months</MenuItem>
              {[
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December',
              ].map((month, index) => (
                <MenuItem key={month} value={String(index)}>
                  {month}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

            {/* <Button
              variant="contained"
              onClick={handleExport}
              disabled={loading}
              sx={{
                ml: 2,
                width: '100px',
                borderRadius:'10px',
                height: '50px',
                padding: '10px 0',
                fontWeight: 'bold',
                backgroundColor: theme.palette.primary.main,
                '&:hover': { backgroundColor: theme.palette.primary.dark },
              }}
            >
              Export
            </Button> */}
        </Box>
          {['teacher', 'admin'].includes(currentUser?.role) && (
         <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  mb: 2,
                }}
              >
                <IconButton
                  onClick={() => setShowUserGuideModal(true)}
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: '50%',
                    minWidth: 0, // Remove MUI's default padding
                  }}
                >
                  <InfoOutlineIcon sx={{ fontSize: 30 }} />
                </IconButton>
              </Box>  )}
      </Box>
<Paper
        sx={{
          paddingBottom: 0,
          maxWidth: '100%',
          boxSizing: 'border-box',
          mx: 'auto',
          backgroundColor: theme.palette.background.paper,
          borderRadius: '16px',
        }}
      >
        <CustomTableScrollbar sx={{ width: '100%', overflowX: 'auto' }}>
          <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
            <Table
              sx={{
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white',
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Admission No.</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Student Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Mobile No.</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Due Months</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Outstanding Fees</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', textAlign: 'center' }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                      <Typography>Loading dues data...</Typography>
                    </TableCell>
                  </TableRow>
                ) : error ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 4, color: 'error.main' }}>
                      <Typography>{error}</Typography>
                    </TableCell>
                  </TableRow>
                ) : paginatedData.length > 0 ? (
                  paginatedData.map((student, index) => (
                    <TableRow
                      key={student.key}
                      sx={{
                        backgroundColor: index % 2 === 0 ? theme.palette.action.hover : 'inherit',
                        '&:hover': { backgroundColor: theme.palette.action.selected },
                      }}
                    >
                      <TableCell>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                      <TableCell>{student.admissionNo}</TableCell>
                      <TableCell>{student.studentName}</TableCell>
                      <TableCell>{student.mobileNo}</TableCell>
                      <TableCell>{student.dueMonthCount}</TableCell>
                      <TableCell>₹ {student.outstandingAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                      <TableCell align="center">
                        <Button variant="outlined" size="small" onClick={() => openStudentDetails(student)}>
                          View
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 4 }}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTableScrollbar>
      </Paper>

      {groupedData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography variant="body2" color={theme.palette.primary.main}>
            Page <strong>{page}</strong> of <strong>{Math.ceil(groupedData.length / rowsPerPage)}</strong>
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(groupedData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(groupedData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>
                Rows
              </InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {rowsPerPageOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Box>
      )}

<Dialog
  open={Boolean(selectedStudent)}
  onClose={() => setSelectedStudent(null)}
  fullWidth
  maxWidth="lg"
  PaperProps={{
    sx: {
      borderRadius: 3,
      backgroundColor: theme.palette.background.paper,
      backgroundImage: 'none',
      maxHeight: '90vh',
    },
  }}
>
  <DialogTitle
    sx={{
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 2,
    }}
  >
    <Box>
      <Typography variant="h6" component="div" sx={{ fontWeight: 700 }}>
        Installment Details
      </Typography>
      <Typography variant="body2" component="div" sx={{ opacity: 0.9 }}>
        {selectedStudent?.studentName} {selectedStudent?.admissionNo ? `• ${selectedStudent.admissionNo}` : ''}
      </Typography>
    </Box>
    <IconButton onClick={() => setSelectedStudent(null)} sx={{ color: '#fff' }} aria-label="Close installment details">
      <CloseIcon />
    </IconButton>
  </DialogTitle>
  <DialogContent sx={{ pt: 2.5 }}>
   
    <CustomTableScrollbar sx={{ width: '100%', overflowX: 'auto',pt:2.5,pb:2.5 }}>
      <TableContainer sx={{ maxHeight: 420, borderRadius: 2, border: `1px solid ${theme.palette.divider}` }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              {['S.No', 'Installment Month', 'Due Date', 'Amount',  'Payment Status', 'Due Type'].map((label) => (
                <TableCell key={label} sx={{ fontWeight: 700, backgroundColor: theme.palette.primary.main, color: '#fff', whiteSpace: 'nowrap' }}>
                  {label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedInstallments.length ? paginatedInstallments.map((item, index) => {
              const date = getInstallmentDate(item);
              const dueType = item.paymentStatus === 'Paid'
                ? 'Paid'
                : date && date < modalNow
                  ? 'Past Due'
                  : date
                    ? 'Upcoming'
                    : 'Date unavailable';
              return (
                <TableRow key={`${item.id}-${index}`} hover>
                  <TableCell>{(modalPage - 1) * modalRowsPerPage + index + 1}</TableCell>
                  <TableCell>{date ? date.toLocaleDateString('en-IN', { month: 'long', year: 'numeric' }) : '—'}</TableCell>
                  <TableCell>{item.installmentDate || '—'}</TableCell>
                  <TableCell>₹ {item.installmentAmount}</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: item.paymentStatus === 'Paid' ? 'success.main' : 'error.main' }}>
                    {item.paymentStatus}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, color: dueType === 'Past Due' ? 'error.main' : dueType === 'Upcoming' ? 'warning.main' : 'success.main' }}>
                    {dueType}
                  </TableCell>
                </TableRow>
              );
            }) : (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 4 }}>No installments found.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </CustomTableScrollbar>
    {selectedInstallments.length > 0 && (
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'stretch', sm: 'center' }, gap: 1.5, mt: 2 }}>
        <Typography variant="body2" color="text.disabled">
          Page {modalPage} of {Math.max(1, Math.ceil(selectedInstallments.length / modalRowsPerPage))} · {selectedInstallments.length} installments
        </Typography>
        <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={1} flexWrap="wrap">
          <IconButton
            aria-label="Previous installment page"
            onClick={() => setModalPage((prev) => Math.max(1, prev - 1))}
            disabled={modalPage === 1}
            sx={{ color: theme.palette.primary.main }}
          >
            <ChevronLeft />
          </IconButton>
          <IconButton
            aria-label="Next installment page"
            onClick={() => setModalPage((prev) => Math.min(Math.ceil(selectedInstallments.length / modalRowsPerPage), prev + 1))}
            disabled={modalPage >= Math.ceil(selectedInstallments.length / modalRowsPerPage)}
            sx={{ color: theme.palette.primary.main }}
          >
            <ChevronRight />
          </IconButton>
          <FormControl size="small" sx={{ minWidth: 100 }}>
            <InputLabel id="modal-installment-rows-label">Rows</InputLabel>
            <Select
              labelId="modal-installment-rows-label"
              value={modalRowsPerPage}
              label="Rows"
              onChange={(event) => {
                setModalRowsPerPage(Number(event.target.value));
                setModalPage(1);
              }}
            >
              {[5, 10, 25, 50].map((option) => <MenuItem key={option} value={option}>{option}</MenuItem>)}
            </Select>
          </FormControl>
        </Stack>
      </Box>
    )}
  </DialogContent>
  <DialogActions sx={{ px: 3, pb: 2 }}>
    <Button variant="contained" onClick={() => setSelectedStudent(null)}>Close</Button>
  </DialogActions>
</Dialog>

<Dialog
  open={deleteDialogOpen}
  onClose={handleDeleteCancel}
>
  <DialogTitle>Confirm Delete</DialogTitle>
  <DialogContent>
    <DialogContentText>
      Are you sure you want to delete this dues record? This action cannot be undone.
    </DialogContentText>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleDeleteCancel} data-app-cancel="true">Cancel</Button>
    <Button onClick={handleDeleteConfirm} color="error" variant="contained">
      Delete
    </Button>
  </DialogActions>
</Dialog>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Import Modal */}
      <Modal
        open={showImportModal}
        onClose={() => setShowImportModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
            maxHeight: '80vh',
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Import Dues
            </Typography>
            <IconButton onClick={() => setShowImportModal(false)} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ maxHeight: 'calc(80vh - 64px)', overflowY: 'auto', padding: '20px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Button
                variant="contained"
                component="label"
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.dark },
                }}
              >
                Select File
                <input type="file" hidden onChange={handleFileChange} />
              </Button>
              {importFile && (
                <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>
                  Selected: {importFile.name}
                </Typography>
              )}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button
                  variant="contained"
                  onClick={handleImport}
                  sx={{
                    mr: 2,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark },
                  }}
                  disabled={!importFile}
                >
                  IMPORT
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => setShowImportModal(false)}
                >
                  CANCEL
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={showUserGuideModal}
        onClose={() => setShowUserGuideModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 800,
            bgcolor: 'background.paper',
            borderRadius: '16px',
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Dues List Management - User Guide
            </Typography>
            <IconButton
              onClick={() => setShowUserGuideModal(false)}
              sx={{ color: '#fff', position: 'absolute', right: 14 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Scrollable Content */}
       <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
  {/* Section 1: View Dues List */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
  >
    ➤ Follow these steps to view the dues list:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8' }}>
    <li>The table displays comprehensive dues information:
      <ul style={{ marginLeft: '20px', lineHeight: '1.6' }}>
        <li>S.No</li>
        <li>Admission No.</li>
        <li>Student Name</li>
        <li>Mobile No.</li>
        <li>Installment Date</li>
        <li>Installment Amount</li>
        <li>Payment Status (color-coded: <span style={{ color: 'green' }}>green</span> for 'Paid', <span style={{ color: 'red' }}>red</span> for 'Unpaid')</li>
      </ul>
    </li>
    <li>If no data matches your criteria, the table displays "No Data Found".</li>
  </ul>

  {/* Section 2: Search Dues */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to search dues:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8' }}>
    <li>Enter your search term in the search bar at the top.</li>
    <li>The search filters across all columns (case-insensitive).</li>
    <li>The table and pagination update dynamically to show matching results.</li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Clear the search bar to view all records.
  </Typography>

  {/* Section 3: Export Dues */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to export dues:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8' }}>
    <li>Click the <strong>Export</strong> button next to the search bar.</li>
    <li>In the live application, this downloads the current data as CSV/Excel.</li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: The export function includes only the currently filtered data.
  </Typography>

  {/* Section 4: Import Dues */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to import dues (future feature, placeholder shown):
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8' }}>
    <li>This feature will be available in the full application (placeholder currently shown).</li>
    <li>To import dues:
      <ul style={{ marginLeft: '20px', lineHeight: '1.6' }}>
        <li>Click the import button to open the modal</li>
        <li>Select <strong>Choose File</strong> to select a CSV/Excel file</li>
        <li>The selected file name will display in the modal</li>
        <li>Click <strong>IMPORT</strong> to process the file (shows success/error notification)</li>
        <li>Click <strong>CANCEL</strong> to close without importing</li>
      </ul>
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: You must select a file before the IMPORT button becomes active.
  </Typography>

  {/* Section 5: Pagination */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to navigate the list:
  </Typography>
  <ul style={{ marginLeft: '20px', lineHeight: '1.8' }}>
    <li>Use the pagination controls at the bottom:
      <ul style={{ marginLeft: '20px', lineHeight: '1.6' }}>
        <li>Left/right arrows to move between pages</li>
        <li>Click page numbers to jump to specific pages</li>
        <li>Rows dropdown to select 5, 10, 25, or 50 rows per page</li>
      </ul>
    </li>
    <li>Displays current page information (e.g., "Page 1 of 2").</li>
    <li>Pagination applies to filtered or searched results.</li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Pagination controls are hidden if no records match your search criteria.
  </Typography>

  {/* Bottom Close Button */}
  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
    {/* Close button can be added here if needed */}
  </Box>
</CustomTableScrollbar>

        </Box>
      </Modal>
    </Container>
  );
};

export default DuesList;